import React from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { useIntl } from 'react-intl';

import { IconContainer, StyledButton } from './loyalty-promo-code-cta.styled';
import { LoyaltyPromoCodeCTAProps } from './types';

export const LoyaltyPromoCodeCTA = ({ onClick }: LoyaltyPromoCodeCTAProps) => {
  const { formatMessage } = useIntl();

  return (
    <StyledButton onClick={onClick}>
      <IconContainer>
        <Icon icon="offer" color="white" aria-hidden width="20px" height="20px" />
      </IconContainer>
      <div>{formatMessage({ id: 'promoCodeCTA' })}</div>
    </StyledButton>
  );
};
